import { render, staticRenderFns } from "./advertNotLive.vue?vue&type=template&id=9554c746&scoped=true"
import script from "./advertNotLive.vue?vue&type=script&lang=js"
export * from "./advertNotLive.vue?vue&type=script&lang=js"
import style0 from "./advertNotLive.vue?vue&type=style&index=0&id=9554c746&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9554c746",
  null
  
)

export default component.exports